<template>
  <zm-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <zm-breadcrumb-item v-for="(item,index) in levelList" :key="item.name + '_' + item.path">
        <span v-if="item.redirect==='noredirect'||index==levelList.length" class="no-redirect">{{item.name}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item key="triggerId" v-if="levelList.length && levelList[1].name === 'Triggers'">
        <span>{{ triggerId }}</span>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item key="kafkaManage" v-if="isKafkaManage">
        <zm-dropdown trigger="click" @command="handleCommand">
          <span class="zm-dropdown-link">
            {{ kafkaPath.name }}<i class="zm-icon-down zm-icon--right"></i>
          </span>
          <zm-dropdown-menu slot="dropdown">
            <zm-dropdown-item v-if="kafkaPath.name !== 'Dashboard'" command="dashboard">Dashboard
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Cluster'" command="cluster">Cluster
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Alert'" command="alert">Alert
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Reassign'" command="reassign">Reassign
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Webhook'" command="webhook">Webhook
            </zm-dropdown-item>
          </zm-dropdown-menu>
        </zm-dropdown>
      </zm-breadcrumb-item>
    </transition-group>
  </zm-breadcrumb>
</template>

<script>
export default {
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      levelList: null,
      isKafkaManage: false,
      kafkaPath: {},
      triggerId: ''
    }
  },
  watch: {
    $route () {
      this.isKafkaManage = false
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.name)
      if (matched.length !== 0) {
        if (matched[1].name === 'Triggers') {
          matched[1].name = 'Triggers'
          matched[1].path = '/dashboard/trigger'
          this.triggerId = this.$route.params.triggerId
        } else if (matched[1].meta.title === 'Describe') {
          matched[1].name = localStorage.channelName
          matched[1].path = '/dashboard/channel'
        } else if (matched[1].meta.title === 'Kafka Manage Describe') {
          matched[1].name = localStorage.channelName
          matched[1].path = '/dashboard/manage/cluster'
        } else if (matched[1].meta.title === 'Service Region' || matched[1].meta.title === 'Client') {
          matched[1].name = this.$route.params.name
          matched[1].path = '/dashboard/smart'
          matched.push({
            name: matched[1].meta.title,
            path: this.$route.path
          })
        } else if (matched[1].meta.title === 'Application' || matched[1].meta.title === 'Service Region Client') {
          matched[1].name = this.$route.params.serviceName
          matched[1].path = '/dashboard/smart'
          matched.push({
            name: this.$route.params.poolName,
            path: '/dashboard/smart/pool/' + this.$route.params.serviceName + '/' + this.$route.params.serviceId
          })
          matched.push({
            name: matched[1].meta.title,
            path: this.$route.path
          })
        } else if (matched[1].meta.title.indexOf('Kafka Manage') > -1) {
          // matched[1] = {
          //   name: 'Kafka Manage',
          //   path: '/dashboard/manage/cluster'
          // }
          this.isKafkaManage = true
          this.kafkaPath = {
            name: this.$route.name,
            path: this.$route.path
          }
          matched.splice(1, 1, {
            name: 'Kafka Manage',
            path: '/dashboard/manage/cluster'
          })
        }
      }
      this.levelList = matched
    },
    handleCommand (command) {
      if (command) {
        this.$router.push('/dashboard/manage/' + command)
      }
    }
  }
}
</script>
<style scoped>
.zm-breadcrumb {
  line-height: 1.5;
}
</style>
<style>
.zm-breadcrumb__inner {
  max-width: 250px;
}
</style>
